import { Injectable } from '@angular/core';
import { GtmEvent } from '../../models/gtm-event.model';
import { Language } from '../../components/language-switcher/language-switcher.model';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  pushEvent(eventData: GtmEvent): void {
    window.dataLayer.push(eventData);
  }

  pushPageDataEvent(language: Language, subCategory: string, pageCategory: string, pagePath: string, pageVariant: string): void{
    // sdp/login/central/b2b/after-sales//mobile//homepage
    //pageName: [siteTypeLevel1]/[siteTypeLevel2]/[siteOwner]/[siteTarget]/[siteFamily]/[code-gabarit]/[mobile-desktop]//[vehicleModelBodystyle]/[pagetitle]
    const dataLayerData = {
      event: "updatevirtualpath",
      brand: "sdp",
      language: language?.languageCode || "",
      country: language?.countryCode?.toLowerCase() || "",
      virtualPageURL: "/sdp/" + pagePath,
      pageName: "gdrp/" + subCategory + "/central/B2B/dealers////"+pageCategory,
      siteTypeLevel1: "gdrp",
      siteTypeLevel2: subCategory|| "",
      siteOwner: "central",
      siteTarget: "B2B",
      siteFamily:  "dealers",
      pageCategory: pageCategory || "",
      pageVariant: pageVariant || "",
    };
    window.dataLayer.push(dataLayerData);
  }
}
